// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_icons.styl
// module id = 65
// module chunks = 0